import type { StateCreator } from 'zustand';
import mediaDetailsSlice, { type MediaDetailsSliceState } from './mediaDetailsSlice';
import mediaEventTableSlice, { type MediaEventSliceState } from './mediaEventTableSlice';
import mediaRequestTableSlice, { type MediaRequestSliceState } from './mediaRequestTableSlice';
import tripImageTableSlice, { type TripImageHistorySliceState } from './tripImageTableSlice';

type MediaSlices = TripImageHistorySliceState & MediaEventSliceState & MediaRequestSliceState & MediaDetailsSliceState;

const mediaSlices: StateCreator<MediaSlices> = (setState, getState, store) => ({
  ...tripImageTableSlice(setState, getState, store),
  ...mediaEventTableSlice(setState, getState, store),
  ...mediaRequestTableSlice(setState, getState, store),
  ...mediaDetailsSlice(setState, getState, store),
});

export type { MediaSlices };
export default mediaSlices;
